// Injects the Google Tag Manager <head> script and <body> noscript iframe programmatically,
// since this is a client-rendered SPA without a build-time-fixed index.html per environment.
export function initGoogleTagManager(gtmId?: string) {
  const w = window as any;

  if (!gtmId || w.dataLayer) {
    return;
  }

  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = false;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  const cmpLoader = document.getElementById('usercentrics-cmp');
  document.head.insertBefore(script, cmpLoader ? cmpLoader.nextSibling : document.head.firstChild);

  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';

  const noscript = document.createElement('noscript');
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}
